import { customValidators } from "src/app/_helpers/customValidators";
import { Component, ElementRef, OnDestroy, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { MenuController } from "@ionic/angular";
import { removeInitScreen } from "src/app/_helpers/appLoading";
import { globalHelper } from "src/app/_helpers/global";
import { Utils } from "src/app/_helpers/utils";
import { UserSessionModel } from "src/app/_models/user-session.model";
import { User } from "src/app/_models/user.model";
import { ConfigService } from "src/app/_services/config.service";
import { AuthService } from "../auth.service";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-register",
  templateUrl: "./register.page.html",
  styleUrls: ["./register.page.scss", "./../../../_styles/ion-grid-box.scss"],
})
export class RegisterPage implements OnInit, OnDestroy {
  constructor(
    public authServ: AuthService,
    private router: Router,
    public menu: MenuController,
    private formBuilder: FormBuilder,
    private configService: ConfigService,
    private el: ElementRef
  ) {}

  validationError = false;
  form: FormGroup;
  subdomain: string;
  passwordEye = false;
  isSubdomain: boolean;
  isSended: boolean = false;
  regulationsAccepted: boolean = false;
  privacyPolicy: boolean = false;
  accountExist: boolean = false;
  appNameDoesntExist: boolean = false;
  userSession: UserSessionModel;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  
  ngOnInit() {
    this.menu.enable(false);
    this.authServ.user = new User();
    this.subdomain = Utils.GetSubdomain(window.location.host);
    this.isSubdomain = this.subdomain ? true : false;
    this.authServ.user.appName = this.subdomain ? this.subdomain : "";

    this.form = this.formBuilder.group({
      appName: new FormControl(this.subdomain, {
        updateOn: "blur",
        validators: [
          Validators.required,
          Validators.maxLength(20),
          customValidators.trimValidator(),
        ],
      }),
      password: new FormControl(null, {
        updateOn: "blur",
        validators: [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(30),
        ],
      }),
      passwordConf: new FormControl(null, {
        updateOn: "blur",
        validators: [Validators.required],
      }),
      firstName: new FormControl(null, {
        updateOn: "blur",
        validators: [
          Validators.required,
          Validators.maxLength(50),
          customValidators.trimValidator(),
        ],
      }),
      lastName: new FormControl(null, {
        updateOn: "blur",
        validators: [
          Validators.required,
          Validators.maxLength(50),
          customValidators.trimValidator(),
        ],
      }),
      email: new FormControl(null, {
        updateOn: "blur",
        validators: [Validators.required, customValidators.emailPattern],
      }),
      rememberMe: new FormControl(true),
    });

    this.form.setValidators(this.comparisonValidator());

    removeInitScreen();
  }

  public comparisonValidator(): ValidatorFn {
    return (group: FormGroup): ValidationErrors => {
      const password = group.controls["password"];
      const passwordConf = group.controls["passwordConf"];

      if (password.value !== passwordConf.value) {
        passwordConf.setErrors({ notEquivalent: true });
      } else {
        passwordConf.setErrors(null);
      }
      return;
    };
  }

  Save() {
    if (!this.form.valid) {
      this.validationError = true;
      globalHelper.scrollToFirstInvalidControl(this.el);
      return;
    }

    if(this.form.controls.appName.value === "") {
      this.authServ.user.appName = Utils.GetSubdomain(window.location.host);
    }

    this.authServ.user.appName = this.form.controls.appName.value.toUpperCase();
    this.authServ.user.email = this.form.controls.email.value;
    this.authServ.user.firstName = this.form.controls.firstName.value;
    this.authServ.user.lastName = this.form.controls.lastName.value;
    this.authServ.user.password = this.form.controls.password.value;

    this.authServ
      .userRegister()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.onRegistred();
        },
        error: (err) => {
          this.onRegistredError(err);
        },
      });
  }

  passwordEyeAction() {
    this.passwordEye = !this.passwordEye;
  }
  
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  private onRegistred() {
    this.authServ.emailAddressSended = this.form.value.email;
    
    this.authServ.user = new User();
    this.isSended = true;
    this.authServ.onSaveLastUSerInLocalStorage(this.form);
  }

  private onRegistredError(err: any) {
    if (err.error.code === 2 || err.error.code === 1) {
      this.accountExist = true;
    } else {
      this.accountExist = false;
    }

    if (err.error.message === 'App instance not exist!') {
      this.appNameDoesntExist = true;
    } else {
      this.appNameDoesntExist = false;
    }
  }
}
